import { api } from './api';
import { normalizeStoreList } from '../utils/storeUtils';

/**
 * Paginated store list (scale-safe). Maps to normalized profile shape.
 */
export async function fetchStoreListPage({
  limit = 50,
  cursor = null,
  q = '',
  includeDisconnected = true,
  connectedOnly = false,
} = {}) {
  const params = {
    limit,
    includeDisconnected: includeDisconnected ? 'true' : 'false',
  };
  if (cursor) params.cursor = cursor;
  if (q) params.q = q;
  if (connectedOnly) params.connectedOnly = 'true';

  const response = await api.get('/stores/list', { params });
  const items = normalizeStoreList(response.data.items || []);
  return {
    items,
    nextCursor: response.data.nextCursor || null,
    hasMore: Boolean(response.data.hasMore),
  };
}

/**
 * Fetch up to maxItems (for small fleets — still uses pages).
 */
export async function fetchAllAccessibleStores({ maxItems = 500, pageSize = 100 } = {}) {
  let cursor = null;
  const all = [];
  while (all.length < maxItems) {
    const page = await fetchStoreListPage({
      limit: pageSize,
      cursor,
      includeDisconnected: true,
    });
    all.push(...page.items);
    if (!page.hasMore || !page.nextCursor) break;
    cursor = page.nextCursor;
  }
  return all.slice(0, maxItems);
}
